export const bikeSpecificationsList = [
  'Frame',
  'Year',
  'Group',
  'Tyre',
  'Wheels',
  'Handlebars',
  'Brakes',
];
